module.exports = __webpack_public_path__ + "static/media/docNavLogoNew.411b01a2.svg";